import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import PartnerControlLayout from './layouts/PartnerControlLayout';
import PenaltyGenerationPage from './penaltyGeneration/PenaltyGenerationPage';
import AppealReviewPage from './appealReview/AppealReviewPage';
import PenaltyCenterPage from './penaltyCenter/PenaltyCenterPage';
import PenaltyDetailPage from './penaltyCenter/PenaltyDetailPage';
import PartnerControlDownloadPage from './download/PartnerControlDownloadPage';

const PartnerControlRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><PartnerControlLayout /></AuthGuard>}>
                <Route path="penaltyReview/generation" element={<PenaltyGenerationPage />} />
                <Route path="penaltyReview/appeal-review" element={<AppealReviewPage />} />
                <Route path="penaltyCenter" element={<PenaltyCenterPage />} />
                <Route path="penaltyCenter/:id" element={<PenaltyDetailPage />} />
                <Route path="download" element={<PartnerControlDownloadPage />} />
            </Route>
        </Routes>
    );
};

export default PartnerControlRoutes;
